import React from 'react';
import { AlertBar } from './components/AlertBar';
import { Hero } from './components/Hero';
import { PainPoints } from './components/PainPoints';
import { Scenarios } from './components/Scenarios';
import { ForWho } from './components/ForWho';
import { ProductOffer } from './components/ProductOffer';
import { Bonuses } from './components/Bonuses';
import { Testimonials } from './components/Testimonials';
import { Guarantee } from './components/Guarantee';
import { Faq } from './components/Faq';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen w-full bg-cream font-sans" data-id="element-0" data-mp="31bib1qblcqh0">
      <AlertBar data-id="element-1" data-mp="2wka1mua9h53u" />
      <main data-id="element-2" data-mp="2wjqhd6x524mn">
        <Hero data-id="element-3" data-mp="2wiyvwox99na3" />
        <PainPoints data-id="element-4" data-mp="2wifgbev2vaz8" />
        <Scenarios data-id="element-5" data-mp="2whxaprmizken" />
        <ForWho data-id="element-6" data-mp="28ufm24yk52fw" />
        <ProductOffer data-id="element-7" data-mp="28tw9l3rof699" />
        <Bonuses data-id="element-8" data-mp="28t4lsf4bmctj" />
        <Testimonials data-id="element-9" data-mp="28sl48zil1qg1" />
        <Guarantee data-id="element-10" data-mp="28s30zixi6bym" />
        <Faq data-id="element-11" data-mp="23vuo6c6s2uum" />
        <FinalCTA data-id="element-12" data-mp="23w4ey1znd61d" />
      </main>
      <Footer data-id="element-13" data-mp="23ut9lxqjzq85" />
    </div>;
}